import { API_DOMAIN } from "../constants";

// ── API endpoints ────────────────────────────────────────────────────────────
export const CHAT_API          = API_DOMAIN + "/wati_messages/fetch_messages";
export const CHAT_MESSAGES_API = API_DOMAIN + "/wati_messages/fetch_specific_chat_messages";
export const SEND_VOICE_API    = API_DOMAIN + "/wati_messages/send_voice_message";
export const SEND_IMAGE_API    = API_DOMAIN + "/wati_messages/send_image_message";
export const SEND_VIDEO_API    = API_DOMAIN + "/wati_messages/send_video_message";
export const SEND_DOCUMENT_API = API_DOMAIN + "/wati_messages/send_document_message";
export const SEND_TEXT_API     = API_DOMAIN + "/wati_messages/send_text_message";
export const SEND_TEMPLATE_API = API_DOMAIN + "/wati_messages/send_template";
export const MARK_AS_READ_API  = API_DOMAIN + "/wati_messages/mark_chat_as_read";

// ── File upload rules ────────────────────────────────────────────────────────
export const MB = 1024 * 1024;
export const KB = 1024;

export const WATI_FILE_RULES = {
  "image/jpeg": { category: "image",    maxBytes: 5   * MB, label: "JPEG" },
  "image/png":  { category: "image",    maxBytes: 5   * MB, label: "PNG" },
  "video/mp4":  { category: "video",    maxBytes: 16  * MB, label: "MP4" },
  "video/3gpp": { category: "video",    maxBytes: 16  * MB, label: "3GP" },
  "audio/aac":  { category: "audio",    maxBytes: 16  * MB, label: "AAC" },
  "audio/mp4":  { category: "audio",    maxBytes: 16  * MB, label: "MP4 Audio" },
  "audio/mpeg": { category: "audio",    maxBytes: 16  * MB, label: "MP3" },
  "audio/amr":  { category: "audio",    maxBytes: 16  * MB, label: "AMR" },
  "audio/ogg":  { category: "audio",    maxBytes: 16  * MB, label: "OGG" },
  "image/webp": { category: "sticker",  maxBytes: 100 * KB, label: "WebP Sticker" },
  "application/pdf":   { category: "document", maxBytes: 100 * MB, label: "PDF" },
  "application/msword": { category: "document", maxBytes: 100 * MB, label: "DOC" },
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document":   { category: "document", maxBytes: 100 * MB, label: "DOCX" },
  "application/vnd.ms-powerpoint":  { category: "document", maxBytes: 100 * MB, label: "PPT" },
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": { category: "document", maxBytes: 100 * MB, label: "PPTX" },
  "application/vnd.ms-excel":  { category: "document", maxBytes: 100 * MB, label: "XLS" },
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": { category: "document", maxBytes: 100 * MB, label: "XLSX" },
  "text/plain":       { category: "document", maxBytes: 100 * MB, label: "TXT" },
  "application/zip":  { category: "document", maxBytes: 100 * MB, label: "ZIP" },
};

export const WATI_ACCEPT_ATTR  = Object.keys(WATI_FILE_RULES).join(",");
export const WATI_ACCEPT_LABEL = "Images: JPEG, PNG (5 MB) · Videos: MP4, 3GP (16 MB) · Audio: AAC, MP3, AMR, OGG (16 MB) · Stickers: WebP 512×512 (100 KB) · Docs: PDF, Word, Excel, PowerPoint, TXT, ZIP (100 MB)";

// ── Ticket status display config ─────────────────────────────────────────────
export const TICKET_STATUS = {
  0: { label: "Unassigned", color: "#cf1322", bg: "#fff1f0", border: "#ff4d4f" },
  1: { label: "Open",       color: "#389e0d", bg: "#f6ffed", border: "#52c41a" },
  2: { label: "Solved",     color: "#0958d9", bg: "#e6f4ff", border: "#91caff" },
  3: { label: "Pending",    color: "#d46b08", bg: "#fff7e6", border: "#ffa940" },
  4: { label: "Expired",    color: "#d48806", bg: "#fffbe6", border: "#ffe58f" },
};

export const TICKET_STATUS_STRING = { 0: "Open", 1: "Open", 2: "Solved", 3: "Pending", 4: "Expired" };

// ── Google Maps ──────────────────────────────────────────────────────────────
export const GMAPS_KEY  = "AIzaSyCKT6hm3CTWMFr56LLdsXUjlZpFHY6ihUs";
export const GMAPS_LIBS = ["places"];
